// extracted by mini-css-extract-plugin
export default {"faq":"faq_faq__cSHgf","box":"faq_box__Gw+-U","answ":"faq_answ__lun+1","icon":"faq_icon__x1XBt"};